import { useState } from 'react';
import {
  Card,
  CardBody,
  Input,
  Button,
  Select,
  SelectItem,
  Textarea,
} from '@nextui-org/react';
import { toast } from 'react-toastify';
import { sendEmail } from 'common/src/api/email';
import { PORTAL_URL } from 'common/src/utils/branding';
import { getAllExporters } from 'common/src/api/exporters';
import { useEffect } from 'react';
import { Exporter } from 'common/src/utils/types';
import Header from '../../../components/layouts/Header';
import { PageLayout } from '../../../components/ui';

const SuperadminUpdates = () => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [selectedExporter, setSelectedExporter] = useState<string>('all');
  const [exporters, setExporters] = useState<Exporter[]>([]);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    const fetchExporters = async () => {
      try {
        const fetchedExporters = await getAllExporters();
        setExporters(fetchedExporters);
      } catch (error) {
        console.error('Error fetching exporters:', error);
        toast.error('Error al cargar las exportadoras');
      }
    };

    fetchExporters();
  }, []);

  const handleSendUpdate = async () => {
    if (!subject.trim() || !message.trim()) {
      toast.error('Por favor complete todos los campos');
      return;
    }

    setSending(true);
    try {
      if (selectedExporter === 'all') {
        // Send to all exporters
        for (const exporter of exporters) {
          await sendEmail({
            exporter_id: exporter.id,
            subject: subject,
            html: message.replace(/\n/g, '<br>'),
            link: PORTAL_URL,
            linkText: 'Ir a FruitMarkets',
          });
        }
      } else {
        // Send to specific exporter
        await sendEmail({
          exporter_id: parseInt(selectedExporter),
          subject: subject,
          html: message.replace(/\n/g, '<br>'),
          link: PORTAL_URL,
          linkText: 'Ir a FruitMarkets',
        });
      }

      toast.success('Actualización enviada correctamente');
      setSubject('');
      setMessage('');
    } catch (error) {
      console.error('Error sending update:', error);
      toast.error('Error al enviar la actualización');
    } finally {
      setSending(false);
    }
  };

  return (
    <PageLayout>
      <Header title="Actualizaciones" />

      <Card>
        <CardBody className="space-y-6">
          <div>
            <Select
              label="Exportadora"
              placeholder="Seleccionar exportadora"
              value={selectedExporter}
              onChange={(e) => setSelectedExporter(e.target.value)}
              className="max-w-md"
            >
              <SelectItem key="all" value="all">
                Todas las exportadoras
              </SelectItem>
              {exporters.map((exporter) => (
                <SelectItem key={exporter.id} value={exporter.id.toString()}>
                  {exporter.name}
                </SelectItem>
              ))}
            </Select>
          </div>

          <Input
            label="Asunto"
            placeholder="Ingrese el asunto del mensaje"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />

          <Textarea
            label="Mensaje"
            placeholder="Escriba su mensaje aquí..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            minRows={5}
          />

          <div className="flex justify-end">
            <Button
              color="primary"
              onClick={handleSendUpdate}
              isLoading={sending}
            >
              Enviar Actualización
            </Button>
          </div>
        </CardBody>
      </Card>
    </PageLayout>
  );
};

export default SuperadminUpdates; 